import { render, staticRenderFns } from "./TourStages.vue?vue&type=template&id=304861b6&scoped=true&"
import script from "./TourStages.vue?vue&type=script&lang=js&"
export * from "./TourStages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304861b6",
  null
  
)

export default component.exports